import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { useState } from "react";
import ProgressiveImage from "react-progressive-image";
import { useNavigate } from "react-router-dom";
import newsletterDefaultImg from "../../../assets/images/defaultImages/imageUpload-img.jpg";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import Tag from "../../../components/tag";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
  const { newsletter, crumps } = props;

  const navigate = useNavigate();
  const classes = styles();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {newsletter.title ? (
        <>
          <Grid container className={classes.topSection}>
            <Grid item xs={12} container justify="flex-start">
              <div>
                <ProgressiveImage
                  src={newsletter.coverPhoto}
                  placeholder={props.placeholder || newsletterDefaultImg}
                >
                  {(src, loading) => (
                    <img
                      style={{
                        opacity: loading ? 0.7 : 1,
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                      src={src}
                      alt="No cover"
                      className={classes.image}
                    />
                  )}
                </ProgressiveImage>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              spacing={2}
              className={classes.infoSection}
            >
              <Grid item className={classes.textInfo}>
                <Typography variant="h4" className={classes.texts}>
                  {newsletter.title}
                </Typography>

                <Grid item className={classes.actions}>
                  <Grid container spacing={2} justify="flex-end">
                    <SingleItemMenu
                      horiz
                      background
                      menu={props.actions}
                      item={newsletter}
                    />
                  </Grid>
                </Grid>

                <Tooltip title="Author" placement="right-end" arrow>
                  <Typography
                    variant="h6"
                    className={classes.name}
                    // onClick={() => goToPage(`/authors/${newsletter.authorEmail}`)}
                  >
                    Author: {newsletter.author?.name || newsletter.author?.id}
                  </Typography>
                </Tooltip>
                <Typography variant="body1" className={classes.texts}>
                  Created: {moment(newsletter.createdAt).fromNow()}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Status: {newsletter.status}
                </Typography>
                <a href={newsletter.pdfUrl} target="_blank">
                  <Typography variant="body1" className={classes.texts}>
                    View pdf..
                  </Typography>
                </a>
                <br />
                <span>
                  {newsletter.tags
                    ? newsletter.tags.map((elt) => (
                        <Tag key={elt} content={elt} />
                      ))
                    : null}
                </span>
              </Grid>
            </Grid>
          </Grid>

          <Grid container className={classes.otherSections} direction="column">
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                Summary
              </Typography>
            </Grid>

            <Grid
              item
              style={{
                width: "100%",
                wordWrap: "break-word",
              }}
            >
              <Typography variant="subtitle1">{newsletter.summary}</Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <NoContent title="Unable to find Newsletter" />
      )}
    </div>
  );
};
